<template>
  <v-dialog :value="filterForm.openStudyResult" max-width="1100" persistent>
    <v-card class="text-center quick-view">
      <v-card-title class="text-sm-left font-weight-bold px-5">
<!--        <span>{{dataStudyResult}}</span>-->
        <div v-if="!_.hasIn(dataStudyResult, 'study_result_multiple')">
          <v-icon size="20" color="pink" class="icon-child-name">mdi-account</v-icon>
          {{ dataStudyResult.fullName }} - {{ dataStudyResult.birthday }}
        </div>
<!--        <v-spacer/>-->

        <v-tabs
            v-else
            class="mt-0 pl-3"
            @change="changeTabTitle"
            v-model="tabTitleIndex"
            color="primary"
            style="background-color: #FFFFFF; padding: 5px 0px 10px 5px;"
        >
          <v-tab v-for="(tab, i) in dataStudyResult.study_result_multiple" :key="i+1">
            <v-icon size="20" color="pink" class="icon-child-name">mdi-account</v-icon>
            {{ tab.user_name }} - {{ tab.yob }}
<!--            {{ tab }}-->
          </v-tab>
        </v-tabs>

        <v-icon aria-label="Close" @click="closeModal">mdi-close</v-icon>
      </v-card-title>
        <v-card-text class="pa-4">
          <div class="d-flex">
            <v-tabs
                class="mt-0 pl-3 col-8"
                @change="changeTab"
                v-model="tabIndex"
                color="primary"
                style="background-color: #FFFFFF; padding: 5px 0px 10px 5px;"
            >
              <v-tab v-for="(tab, i) in timeOptions" :key="i+1">{{ tab }}</v-tab>
            </v-tabs>
            <span class="col-4" style="margin-top: 10px">
              <b style="font-size:16px!important;font-weight:500">
                Số lượt xem bài học:
                <span style="font-size:16px!important" v-if="isNaN(parseInt(dataStudyResultLocaly.view_video_lesson))">0</span>
                <span style="font-size:16px!important" v-else>{{ dataStudyResultLocaly.view_video_lesson }}</span>
              </b> 
            </span>
          </div>

          <v-simple-table class="table-layout pa-4 pt-0">
            <template v-slot:default>
              <thead>
              <tr>
                <th>Môn</th>
<!--                <th>Số câu bài tập</th>-->
<!--                <th >-->
<!--                  <v-icon color="green">mdi-checkbox-marked-circle</v-icon>-->
<!--                </th>-->
<!--                <th>-->
<!--                  <v-icon color="red">mdi-close-circle</v-icon>-->
<!--                </th>-->
<!--                <th>Điểm trung bình (hệ điểm 10)</th>-->
                <th>Hạn</th>
              </tr>
              </thead>
              <tbody>
                <tr v-for="item in dataStudyResultLocaly.study_result">
                  <td class="text-left">{{ item.subject_name }}</td>
<!--                  <td>{{ item.total_question }}</td>-->
<!--                  <td>{{ item.total_question_correct }}</td>-->
<!--                  <td>{{ item.total_question_wrong }}</td>-->
<!--                  <td>{{ Number.isFinite(item.medium_score) ? item.medium_score : '' }}</td>-->
                  <td>{{ item.start_date }} - {{ item.end_date }}</td>
                </tr>
                <tr>
                  <td></td>
<!--                  <td></td>-->
<!--                  <td></td>-->
<!--                  <td></td>-->
<!--                  <td></td>-->
                  <td v-if="dataStudyResultLocaly.performance !== 'Lười học'"
                      class="postison-relative-custom font-weight-bold">
                    <v-icon class="achievements-icon pr-1" color="pink">mdi-medal</v-icon>
                    Tổng kết: {{ dataStudyResultLocaly.performance }}
                  </td>
                  <td v-else class="postison-relative-custom font-weight-bold">
                    <v-icon class="achievements-icon pr-1" color="pink">mdi-medal</v-icon>
                    Tổng kết: Bình thường
                  </td>
                </tr>
              </tbody>

<!--             <tbody v-else>-->
<!--               <tr v-for="item in dataComplexStudyResult.study_result">-->
<!--                 <td class="text-left">{{ item.subject_name }}</td>-->
<!--                 <td>{{ item.total_question }}</td>-->
<!--                 <td>{{ item.total_question_correct }}</td>-->
<!--                 <td>{{ item.total_question_wrong }}</td>-->
<!--                 <td>{{ item.start_date }} - {{ item.end_date }}</td>-->
<!--               </tr>-->
<!--               <tr>-->
<!--                 <td></td>-->
<!--                 <td></td>-->
<!--                 <td></td>-->
<!--                 <td></td>-->
<!--                 <td class="postison-relative-custom font-weight-bold">-->
<!--                   <v-icon class="achievements-icon pr-1" color="pink">mdi-medal</v-icon>-->
<!--                   Tổng kết: {{ dataComplexStudyResult.performance }}-->
<!--                 </td>-->
<!--               </tr>-->
<!--             </tbody>-->
           </template>
         </v-simple-table>
        </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style lang="css" scoped>
/deep/ .icon-child-name {
  position: inherit !important;
  padding-right: 10px;
  top: unset !important;
  right: unset !important;
}
.quick-view table thead tr th {
  font-size: 16px !important;
}

.quick-view table tr td {
  font-size: 13px !important;
}
</style>

<script>
import RepositoryFactory from '../../../repositories/RepositoryFactory';
const ContactRepository = RepositoryFactory.get('contact');
import * as moment from "moment";

export default {
  props: {
    filterForm: {
      default: () => ({})
    },
    dataStudyResult: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showModal: false,
      errorMessage: '',
      // timeOptions: ["3 tháng", "6 tháng", "1 năm", "Tất cả"],
      timeOptions: ["Tất cả"],
      tabIndex: 0,
      startTime: '',
      endTime: '',
      dataStudyResultLocaly: _.cloneDeep(this.dataStudyResult),
      tabTitleIndex: 0,
      listDataComplexStudyResult: []
    };
  },
  created() {
    if(_.hasIn(this.dataStudyResult, 'study_result_multiple')) {
      this.listDataComplexStudyResult =  this.dataStudyResult.study_result_multiple;
      this.changeTabTitle();
    }
  },
  methods: {
    closeModal() {
      this.filterForm.openStudyResult = false;
    },
    changeTab() {
      this.endTime = moment().format('YYYY-MM-DD')
      if (this.tabIndex === 0) {
        this.startTime = moment().subtract(3, 'months').format('YYYY-MM-DD');
      } else if (this.tabIndex === 1) {
        this.startTime = moment().subtract(6, 'months').format('YYYY-MM-DD');
      } else if (this.tabIndex === 2) {
        this.startTime = moment().subtract(1, 'year').format('YYYY-MM-DD');
      } else if (this.tabIndex === 3) {
        this.startTime = '';
        this.endTime = '';
      }
      this.getStudyResult();
    },
    async getStudyResult() {
      let params = {
        startTime: this.startTime,
        endTime: this.endTime
      }
      if(_.hasIn(this.dataStudyResult, 'study_result_multiple')) {
        params.fullName = this.dataStudyResultLocaly.user_name ? this.dataStudyResultLocaly.user_name : this.dataStudyResultLocaly.fullName;
      } else {
        params.fullName = this.dataStudyResult.fullName;
      }
      if (this.dataStudyResult.vhUserId) {
        params.user_id = this.dataStudyResult.vhUserId
      }
      if(this.dataStudyResultLocaly.user_id) {
        params.user_id = this.dataStudyResultLocaly.user_id
      }
      // if(this.tabIndex !== 3) {
      //   params.startTime = this.startTime
      //   params.endTime = this.endTime
      // }
      let res = await ContactRepository.getResultStudy(this.dataStudyResult.contactId, params);
      if(res.success && _.isArray(res.data)) {
        this.listDataComplexStudyResult = _.get(res, 'data', []);
        this.dataStudyResultLocaly = this.listDataComplexStudyResult[this.tabTitleIndex]
      } else if(res.success) {
        this.dataStudyResultLocaly = _.get(res, 'data', {});
      }
    },
    changeTabTitle() {
      this.dataStudyResultLocaly =  this.listDataComplexStudyResult[this.tabTitleIndex];
    }
  }
};
</script>
